import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ApiService} from '../../../utils/services/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Provider, ProviderClass, ProviderParameter} from './resolver/provider-characteristic-resolver.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-provider-characteristic',
  templateUrl: './provider-characteristic.component.html',
  styleUrls: ['./provider-characteristic.component.css']
})
export class ProviderCharacteristicComponent implements OnInit {

  public providers: Array<Provider> = [];
  public selectedProvider: Provider;
  public selectedProviderClass: ProviderClass;
  public providerClassForm: FormGroup;

  constructor(private apiService: ApiService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private notificationsService: NotificationsService,
              private changeDetectionRef: ChangeDetectorRef) {
  }

  ngOnInit() {

    this.activatedRoute.data.subscribe((data) => {
      this.providers = data.data;

      if (this.providers.length > 0 && !this.selectedProvider) {
        this.selectedProvider = this.providers[0];
      } else if (this.providers.length && this.selectedProvider) {
        //this.selectedProvider = this.providers.find((provider) => provider.name === this.selectedProvider.name);
        this.onProviderSelected(this.providers.find((provider) => provider.name === this.selectedProvider.name));

      }

      this.changeDetectionRef.markForCheck();

    });
  }

  searchText(searchText) {

  }

  providersValidClassCount(provider: Provider) {
    return provider.classes.filter((item) => item.ruleText && item.baggage && item.isRefundable).length;
  }

  onProviderSelected(provider: Provider) {
    this.selectedProvider = provider;
    this.selectedProviderClass = null;
  }

  onProviderClassSelected(providerClass: ProviderClass) {

    this.providerClassForm = new FormGroup({
      'name': new FormControl(null, Validators.required),
      'isRefundable': new FormControl(null, Validators.required),
      'baggage': new FormControl(null, Validators.required),
      'baggageType': new FormControl(null, Validators.required),
      'ruleText': new FormControl(null)
    });

    this.selectedProviderClass = providerClass ? providerClass : new ProviderClass();

    if (this.selectedProviderClass.name) {
      this.providerClassForm.controls.name.patchValue(this.selectedProviderClass.name);
    }

    if (this.selectedProviderClass.isRefundable) {
      this.providerClassForm.controls.isRefundable.patchValue(this.selectedProviderClass.isRefundable.value === 'true');
    }

    if (this.selectedProviderClass.ruleText) {
      this.providerClassForm.controls.ruleText.patchValue(this.selectedProviderClass.ruleText.value);
    }

    if (this.selectedProviderClass.baggage) {
      this.providerClassForm.controls.baggage.patchValue(this.selectedProviderClass.baggage.value);
      this.providerClassForm.controls.baggageType.patchValue(this.selectedProviderClass.baggage.context);
    }

  }

  saveChanges() {
    if (this.providerClassForm.valid) {
      let requests: Array<Observable<any>> = [];


      let baggageParameter: ProviderParameter = new ProviderParameter();
      baggageParameter.provider = this.selectedProvider.name;
      baggageParameter.class = this.providerClassForm.controls.name.value;
      baggageParameter.key = 'baggage';
      baggageParameter.value = this.providerClassForm.controls.baggage.value;
      baggageParameter.context = this.providerClassForm.controls.baggageType.value;
      if (this.selectedProviderClass.baggage) {
        requests.push(this.apiService.updateProviderCharacteristic(this.selectedProviderClass.baggage.id, baggageParameter));
      } else {
        requests.push(this.apiService.addProviderCharacteristic(baggageParameter));
      }

      let isRefundableParameter: ProviderParameter = new ProviderParameter();
      isRefundableParameter.provider = this.selectedProvider.name;
      isRefundableParameter.class = this.providerClassForm.controls.name.value;
      isRefundableParameter.key = 'isRefundable';
      isRefundableParameter.value = this.providerClassForm.controls.isRefundable.value ? 'true' : 'false';
      isRefundableParameter.context = this.providerClassForm.controls.isRefundable.value ? 'true' : 'false';
      if (this.selectedProviderClass.isRefundable) {
        requests.push(this.apiService.updateProviderCharacteristic(this.selectedProviderClass.isRefundable.id, isRefundableParameter));
      } else {
        requests.push(this.apiService.addProviderCharacteristic(isRefundableParameter));
      }

      let ruleParameter: ProviderParameter = new ProviderParameter();
      ruleParameter.provider = this.selectedProvider.name;
      ruleParameter.class = this.providerClassForm.controls.name.value;
      ruleParameter.key = 'rule';
      ruleParameter.value = this.providerClassForm.controls.ruleText.value;
      ruleParameter.context = this.providerClassForm.controls.ruleText.value;
      if (this.selectedProviderClass.ruleText) {
        if (this.providerClassForm.controls.ruleText.value && this.providerClassForm.controls.ruleText.value.length > 0) {
          requests.push(this.apiService.updateProviderCharacteristic(this.selectedProviderClass.ruleText.id, ruleParameter));
        } else {
          requests.push(this.apiService.deleteProviderCharacteristicByID(this.selectedProviderClass.ruleText.id));
        }
      } else {
        if (this.providerClassForm.controls.ruleText.value && this.providerClassForm.controls.ruleText.value.length > 0) {
          requests.push(this.apiService.addProviderCharacteristic(ruleParameter));
        }
      }


      Observable.forkJoin(requests).subscribe(
        response => {
          this.notificationsService.success('Success', 'Provider parameter is updated');
          this.router.navigate(['./'], {relativeTo: this.activatedRoute});
        }, error => {
          this.notificationsService.error('Error', 'Error occured');
          this.router.navigate(['./'], {relativeTo: this.activatedRoute});
        }
      );

    }
  }

  deleteProviderClass() {
    let requests: Array<Observable<any>> = [];

    if (this.selectedProviderClass.baggage) {
      requests.push(this.apiService.deleteProviderCharacteristicByID(this.selectedProviderClass.baggage.id));
    }

    if (this.selectedProviderClass.isRefundable) {
      requests.push(this.apiService.deleteProviderCharacteristicByID(this.selectedProviderClass.isRefundable.id));
    }

    if (this.selectedProviderClass.ruleText) {
      requests.push(this.apiService.deleteProviderCharacteristicByID(this.selectedProviderClass.ruleText.id));
    }

    Observable.forkJoin(requests).subscribe(
      response => {
        this.notificationsService.success('Success', 'Provider parameter is deleted');
        this.router.navigate(['./'], {relativeTo: this.activatedRoute});
      }, error => {
        this.notificationsService.error('Error', 'Error occured');
        this.router.navigate(['./'], {relativeTo: this.activatedRoute});
      }
    );


  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/provider-characteristic/provider-characteristic.component.ts